import React, { useState } from "react";
import "./Application.css";

function JobApplication() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [jobRole, setJobRole] = useState("");
  const [experience, setExperience] = useState("");
  const [currentCtc, setCurrentCtc] = useState("");
  const [expectedCtc, setExpectedCtc] = useState("");
  const [jobSector, setJobSector] = useState("");
  const [portfolioUrl, setPortfolioUrl] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [resumeError, setResumeError] = useState("");
  const [portfolioError, setPortfolioError] = useState("");

  const handleFileSelection = (event) => {
    const file = event.target.files?.[0] || null;
    if (!file) {
      setSelectedFile(null);
      setResumeError("");
      return;
    }

    const isPdf = file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");
    if (!isPdf) {
      setSelectedFile(null);
      setResumeError("Please choose a PDF résumé.");
      event.target.value = "";
      return;
    }

    setSelectedFile(file);
    setResumeError("");
  };

  const handleSubmit = (event) => {
    let invalid = false;

    if (!selectedFile) {
      setResumeError("Please choose a PDF résumé before submitting.");
      invalid = true;
    }

    if (jobSector === "IT" && !portfolioUrl.trim()) {
      setPortfolioError("Please enter a portfolio URL for IT applications.");
      invalid = true;
    } else {
      setPortfolioError("");
    }

    if (invalid) event.preventDefault();
  };

  return (
    <>
      <div className="HD09017">
        <h1 className="HGS071100">Apply for Opportunities with Quarec Resources</h1>
        <p className="D81opq">
          Share your experience and résumé so our recruitment team can review your details for suitable opportunities.
          Submitting this form does not guarantee that a vacancy is available, that you will be shortlisted, or that a
          placement will be made.
        </p>
      </div>

      <div className="Vamjhg0817">
        <form
          action="https://quarecres.mcxcontrol.com/form.php"
          method="post"
          encType="multipart/form-data"
          onSubmit={handleSubmit}
        >
          <div className="VGAlop">
            <label className="HFSgh09716" htmlFor="candidate-name">Full Name</label>
            <input
              id="candidate-name"
              className="NameFiled"
              type="text"
              placeholder="Enter your full name"
              value={name}
              onChange={(event) => setName(event.target.value)}
              name="full_name"
              autoComplete="name"
              minLength={2}
              required
            />
          </div>

          <div className="Vag0poqw">
            <div className="HGSDjdf">
              <label className="HFSgh09716" htmlFor="candidate-email">Email Address</label>
              <input
                id="candidate-email"
                className="NameFiled"
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                name="email"
                autoComplete="email"
                required
              />
            </div>
            <div className="HGSDjdf">
              <label className="HFSgh09716" htmlFor="candidate-phone">Phone Number</label>
              <input
                id="candidate-phone"
                className="NameFiled"
                type="tel"
                inputMode="tel"
                pattern="[0-9+() -]{7,20}"
                placeholder="Include country code if needed"
                value={mobile}
                onChange={(event) => setMobile(event.target.value)}
                name="phone_number"
                autoComplete="tel"
                required
              />
            </div>
          </div>

          <div className="Vag0poqw">
            <div className="HGSDjdf">
              <label className="HFSgh09716" htmlFor="candidate-role">Job Role</label>
              <input
                id="candidate-role"
                className="NameFiled"
                type="text"
                placeholder="Role you are interested in"
                value={jobRole}
                onChange={(event) => setJobRole(event.target.value)}
                name="job_role"
                required
              />
            </div>
            <div className="HGSDjdf">
              <label className="HFSgh09716" htmlFor="candidate-experience">Years of Experience</label>
              <input
                id="candidate-experience"
                className="NameFiled"
                type="number"
                min="0"
                max="60"
                step="1"
                placeholder="Years of experience"
                value={experience}
                onChange={(event) => setExperience(event.target.value)}
                name="experience"
                required
              />
            </div>
          </div>

          <div className="Vag0poqw">
            <div className="HGSDjdf">
              <label className="HFSgh09716" htmlFor="candidate-current-ctc">Current CTC (annual)</label>
              <input
                id="candidate-current-ctc"
                className="NameFiled"
                type="number"
                min="0"
                step="any"
                placeholder="Current annual CTC, if applicable"
                value={currentCtc}
                onChange={(event) => setCurrentCtc(event.target.value)}
                name="current_ctc"
                required
              />
            </div>
            <div className="HGSDjdf">
              <label className="HFSgh09716" htmlFor="candidate-expected-ctc">Expected CTC (annual)</label>
              <input
                id="candidate-expected-ctc"
                className="NameFiled"
                type="number"
                min="0"
                step="any"
                placeholder="Expected annual CTC"
                value={expectedCtc}
                onChange={(event) => setExpectedCtc(event.target.value)}
                name="expected_ctc"
                required
              />
            </div>
          </div>

          <div className="Vag0poqw">
            <div className="HGSDjdf">
              <label className="HFSgh09716" htmlFor="candidate-sector">Job Sector</label>
              <select
                id="candidate-sector"
                className="NameFiled"
                value={jobSector}
                onChange={(event) => {
                  setJobSector(event.target.value);
                  if (event.target.value !== "IT") setPortfolioError("");
                }}
                style={{ borderBlockColor: "#2F7175" }}
                name="job_sectors"
                required
              >
                <option value="">Select a sector</option>
                <option value="IT">IT</option>
                <option value="non-IT">Non-IT</option>
              </select>
            </div>
            {jobSector === "IT" && (
              <div className="HGSDjdf">
                <label className="HFSgh09716" htmlFor="candidate-portfolio">Portfolio URL</label>
                <input
                  id="candidate-portfolio"
                  className="NameFiled"
                  type="url"
                  value={portfolioUrl}
                  onChange={(event) => {
                    setPortfolioUrl(event.target.value);
                    setPortfolioError("");
                  }}
                  placeholder="https://example.com"
                  name="profile_url"
                  required
                />
                {portfolioError && <div className="COnFom" role="alert">{portfolioError}</div>}
              </div>
            )}
          </div>

          <div className="Vakg09651">
            <label className="HFSgh09716" htmlFor="candidate-resume">Résumé (PDF only)</label>
            <input
              id="candidate-resume"
              name="resume"
              accept=".pdf,application/pdf"
              className="UploadInput"
              type="file"
              onChange={handleFileSelection}
              required
            />
            {resumeError && <div className="COnFom" role="alert">{resumeError}</div>}
          </div>

          <button className="Shayiu-btn" type="submit">Submit Application</button>
          <p>
            By submitting your application, you agree that Quarec Resources may use the information you provide to assess
            and respond to your application. Please share only information needed for recruitment. See our{" "}
            <a href="/Privacypolicy">Privacy Policy</a> for details.
          </p>
        </form>
      </div>
    </>
  );
}

export default JobApplication;
